import { useState, useContext } from 'react';
import { EditContext } from '@/context/EditContext';
import { getZIndex } from '@/components/Timeline/utils.ts';

export default function VideoComponent() {
  const {
    // projectDetail, // 项目详情数据
    diyContentStyle,
    videoMaterial,
    // showVideo,
  } = useContext(EditContext);

  const [videoLoaded, setVideoLoaded] = useState(false);

  const renderContentStyle = () => {
    if (JSON.stringify(diyContentStyle) === '{}') {
      return {};
    }
    return {
      objectFit: diyContentStyle?.fillModeEnum === 0 ? 'cover' : 'contain',
      border: `${diyContentStyle?.frame?.border?.size}px solid ${hexToRgba(diyContentStyle?.frame?.border?.color, diyContentStyle?.frame?.border?.opacity)}`,
      borderRadius: `${diyContentStyle?.frame?.radius}px`,
      boxShadow: `${!diyContentStyle?.frame?.shadow?.show ? `${diyContentStyle?.frame?.shadow?.xOffset}px ${diyContentStyle?.frame?.shadow?.yOffset}px ${diyContentStyle?.frame?.shadow?.blur}px ${hexToRgba(diyContentStyle?.frame?.shadow?.color, diyContentStyle?.frame?.shadow?.opacity)}` : 'none'}`,
    };
  };
  const renderStyle = () => {
    // 检查对应视频是否已加载
    if (!videoLoaded) {
      return {};
    }
    return renderContentStyle();
  };
  // 将16进制颜色和透明度转换为rgba格式
  const hexToRgba = (hex, opacity) => {
    if (!hex && hex !== 0) return;
    // 移除存在的#号
    hex = hex.replace('#', '');

    // 将hex转为rgb
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // 计算透明度值(0-100转为0-1)
    let alpha = 0;
    if (opacity > 0) {
      alpha = opacity ? opacity / 100 : 1;
    } else {
      alpha = 0;
    }

    // 返回rgba格式
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };
  return (
    <div>
      <div id="video1" className="video-wrapper" style={{ zIndex: 2 }}>
        {videoMaterial.details?.map((detail) => (
          <video
            id={`videoLabel${detail.id}`}
            key={detail.id}
            src={videoMaterial.oriUrl}
            className="video_content"
            muted
            crossOrigin="anonymous"
            onLoadedData={() => {
              setVideoLoaded(true);
            }}
            style={{ ...renderStyle(), zIndex: getZIndex(detail.trackIndex) }}
          />
        ))}
      </div>
    </div>
  );
}
